import React, { useEffect, useRef, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom'
import { axiosInstance } from '../Config'
import Loader from '../Loader'
import PaymentTable from './SupportTable'
import { Modal } from 'antd'
import { toast } from 'react-toastify'
import secureLocalStorage from 'react-secure-storage' 
import moment from 'moment'

const SupportIndex = () => {

    const [data, setData] = useState([])
    const [payments, setPayments] = useState([])
    const [loading, setLoading] = useState(false)
    const [viewModal, setViewModal] = useState(false)
    const [addModal, setAddModal] = useState(false)
    const [editModal, setEditModal] = useState(false)

    const [subject, setSubject] = useState('')
    const [queryText, setQueryText] = useState('')
    const users = secureLocalStorage.getItem('credentials');

    const [currentEnquiryData, setCurrentEnquiryData] = useState({})

    useEffect(() => {
        window.scrollTo(0, 0)
        getEnquiries()
    }, [])

    function getEnquiries() {
        setLoading(true)
        axiosInstance.get(`get-query/${users.id}`,{
            headers : {
                Authorization : `Bearer ${users.token}`
            }
        })
            .then(res => {
                if(res?.data?.stauts === "fail"){
                    setData([])
                    setPayments([]);
                }else{
                    setData(res?.data?.data)
                    setPayments(res?.data?.data)
                    // console.log(res.data.data)
                }        
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }


    // ==========================================================================================
    const [page, setPage] = useState(1)

    useEffect(() => window.scrollTo(0, 0), [])

    const navigate = useNavigate()

    const [items_perpage, setItemsPerPage] = useState(10)

    const total_pages = Math.ceil(data?.length / items_perpage);

    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const filterByName = (e) => {
        const filteredData = payments.filter((session) =>
            session.title.toLowerCase().includes(e.target.value.toLowerCase()) 
        )
        setData(filteredData)
    }

    const handleAddQuery = async(e) => {
        e.preventDefault();
        try{
            setLoading(true);
            const formdata = new FormData();
            formdata.append("user_id",users.id);
            formdata.append("title" , subject);
            formdata.append("message" , queryText);

            const res = await axiosInstance.post(`add-query` , formdata , {
                headers : {
                    Authorization : `Bearer ${users.token}`
                }
            })

            if(res?.data?.success === true){
                setLoading(false);
                toast.success("Query Submitted");
                setTimeout(() => {
                    getEnquiries()
                }, 1000);
                
            }else{
                setLoading(false);
                toast.error("Something Went Wrong");
            }

        }catch(e){
            setLoading(false);
            console.log("Error" , e);
            toast.error("Something Went Wrong");
        }
        setSubject('')
        setQueryText('')
        setAddModal(false)
    }
    const chatContainerRef = useRef(null);

    const scrollToBottom = () => {
        // Ensure the container exists before trying to scroll
        if (viewModal && chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    };

    useEffect(() => {
        // Delay the scroll action to ensure DOM updates first
        const timer = setTimeout(() => {
            scrollToBottom();
        }, 100); // Small delay to ensure content is rendered

        return () => clearTimeout(timer); // Cleanup on component unmount or re-render
    }, [viewModal, currentEnquiryData]);

    const [loading2 ,setLoading2] = useState(false);
    const [Messages,setMessages] =useState([])

    function getMessgaes(id){
        setLoading(true)
        axiosInstance.post(`/support/messages`, {support_id : id} ,{
            headers : {
                Authorization : `Bearer ${users.token}`
            }
        })
            .then(res => {
                setCurrentEnquiryData(res?.data?.support)
                setMessages(res?.data?.messages);  
                setViewModal(true);    
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    const [NewMessage , setNewMessage] = useState('');

    const handleaddmessage = async() => {
        try{
            const Formdata = new FormData();
            setLoading2(true);

            Formdata.append("parent_id" , Messages[Messages.length - 1]?.id || null);
            Formdata.append("support_id" , currentEnquiryData?.id);
            Formdata.append("message" , NewMessage);
            Formdata.append("sender_id",users?.id)
            Formdata.append("sender_role" , "user");

            const response = await axiosInstance.post("support/messages/send" , Formdata , {
                headers : {
                    Authorization : `Bearer ${users.token}`
                }
            })

            if(response.data.success === true){
                getMessgaes(currentEnquiryData?.id);
                setNewMessage('');
            }else{
                toast.error("Message Not Send");
            }
            setLoading2(false);

        }catch(e){
            toast.error("Message Not Send!");
            setViewModal(false);
        }
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Support" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-5" style={{ minHeight: '75vh' }}>

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search  d-flex justify-content-end mb-4">
                                        <div
                                            className="ps-form--search-simple"
                                        >
                                            <input
                                                className="form-control bg-white"
                                                type="text"
                                                onChange={filterByName}
                                                placeholder="Search Queries.."
                                            />
                                            <button>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>
                                        <select className='form-select ms-3 fs-5'
                                            value={items_perpage}
                                            onChange={(e) => setItemsPerPage(e.target.value)}
                                            style={{ width: '110px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>
                                    </div>
                                    <div className='text-end'>
                                        <button type="button" className="button btn-green color-white"
                                            onClick={() => setAddModal(true)}>
                                            <i className='icon-plus me-3 fs-5'></i>
                                            Add Query</button>
                                        <button type="button" onClick={() => navigate(-1)} className="button btn-black text-white ms-3">
                                            <i className='icon-arrow-left me-3 fs-5'></i>
                                            back</button>
                                    </div>
                                </div>

                                <PaymentTable
                                    data={final_data}
                                    getMessgaes={getMessgaes}
                                />

                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>

                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`}
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>

                                        {
                                            [...Array(total_pages)].map((_, pagecount) => {
                                                pagecount += 1
                                                return (
                                                    <>
                                                        <div key={pagecount} className={`bd-number-pagination rounded-2 mt-2 mx-1 pe-1 ${page === pagecount && 'activepage'}`} onClick={() => changePage(pagecount)}>
                                                            {pagecount < 10 ? ('0' + pagecount) : pagecount}
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }

                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`}
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>

            {/* Add */}
            <Modal
                open={addModal}
                title="Add your query"
                centered
                onCancel={() => setAddModal(false)}
                width={720}
                bodyStyle={{ padding: '0' }}
                footer={null}
            >
                <div className="bg-gradientt p-4 pb-5">
                    <form onSubmit={handleAddQuery} >
                        <div className='row '>
                            <div className="col-12 px-4">
                                <div className="input-field ">
                                    <label htmlFor="subject" className='label'>
                                        <input type="text" id="subject"
                                            value={subject}
                                            onChange={(e) => setSubject(e.target.value)}
                                            required
                                            placeholder="Subject" />
                                        <span>Subject <i className="text-danger">*</i></span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-12 px-4">
                                <label for="" className="text-green ps-3 mb-1">Message <i className="text-danger">*</i></label>

                                <textarea rows="4" placeholder="Type your query here.."
                                    value={queryText}
                                    onChange={(e) => setQueryText(e.target.value)}
                                    required
                                    className="bg-white text-area-input p-3"></textarea>
                            </div>
                            <div className='col-md-12 ps-4 mt-4'>
                                <button type="submit" className="button btn-green color-white" >
                                    Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* View */}
            <Modal
                open={viewModal}
                title="Support Chat: Where Admins and Instructors Meet"
                centered
                onCancel={() => setViewModal(false)}
                width={800}
                bodyStyle={{ padding: '0' }}
                footer={null}
            >

                <div className="bg-gradientt p-4 pb-5 d-flex flex-column justify-content-between" style={{height:"550px"}}>
                    <div className='Chat-Data-Show' ref={chatContainerRef}>
                        <div>
                            <div className='d-flex align-items-center text-center'>
                                <span className='line'></span>
                                <span className='fs-4'>{moment(Messages[0]?.created_at).format("DD-MM-YYYY")}</span>
                                <span className='line'></span>
                            </div>
                            <div className='text-end fw-semi-bold text-green me-4 mb-1 fs-4'>User Query <i className='bi bi-person-fill'></i></div>
                            <div className='d-flex justify-content-end'>
                                <div className='d-flex align-items-end pb-2 pe-2'>
                                    <span>{moment(Messages[0]?.created_at).format("HH:mm")}</span>
                                </div>
                                <div className='Client-Response bg-green text-white mx-2 rounded-4'>
                                    <div>
                                        <label htmlFor="" className='fw-bold d-block'>Subject</label>
                                        {currentEnquiryData?.title}
                                    </div>
                                    <div className='mt-3'>
                                        <label htmlFor="" className='fw-bold d-block'> Query</label>
                                        {Messages[0]?.message}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='mt-5'>
                            {Messages.slice(1).map((message, index) => (
                                <div key={index}>
                                {/* If the message is from the user */}
                                {message.usertype === 'user' && (
                                    <div className='d-flex align-items-center text-center'>
                                    <span className='line'></span>
                                    <span className='fs-4'>{moment(message.created_at).format("DD-MM-YYYY")}</span>
                                    <span className='line'></span>
                                    </div>
                                )}
                                
                                {/* User Query */}
                                {message.sender_role === 'staff' && (
                                    <div className='mb-3'>
                                        <div className='fw-semi-bold text-green ms-4 mb-1 fs-4'>
                                            Admin Reply <i className='bi bi-person-fill'></i>
                                        </div>
                                        <div className='d-flex justify-content-start'>
                                            <div className='Client-Response bg-white mx-2 rounded-4'>
                                            <div>{message.message}</div>
                                            </div>
                                            <div className='d-flex align-items-end pb-2 ps-2'>
                                            <span>{moment(message.created_at).format("HH:mm")}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Admin Reply */}
                                {message.sender_role === 'user' && (
                                    <div className='mb-3'>
                                        <div className='text-end mt-4 fw-semi-bold text-black fs-4 me-4 mb-1'>
                                            User Query <i className='bi bi-person-fill ms-2 fs-4'></i>
                                        </div>
                                        <div className='d-flex justify-content-end'>
                                            <div className='d-flex align-items-end pb-2 pe-2'>
                                            <span>{moment(message.updated_at).format("HH:mm")}</span>
                                            </div>
                                            <div className='Admin-Response text-end bg-green text-white rounded-4 mx-4'>
                                            {message.message}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='mt-5 pt-4 mx-2'>
                        <hr/>
                        <div className='d-flex justify-content-between'>
                            {
                                currentEnquiryData?.response ? (
                                    <div className='Completed rounded-4 text-center w-100'>
                                        <p className='text-white mb-0 fs-4'>Query Has been Closed by Admin, Please Add new query for further Questions.</p>
                                    </div>
                                ):(
                                    <>
                                        <div className="col-10">
                                            <div className="input-field">
                                                <input type="text" id="subject"
                                                    value={NewMessage}
                                                    className='chat-response Chat-input mt-0 text-black'
                                                    onChange={(e) => setNewMessage(e.target.value)}
                                                    required
                                                    placeholder='Message'
                                                />
                                            </div>
                                        </div>
                                        <button onClick={handleaddmessage} className='ps-dropdown__toggle rounded-4 border-0 bg-green text-white me-3 px-4'>
                                        <i className={`bi bi-${loading2 ? 'arrow-repeat rotation me-3' : 'send-fill'} me-2`}> </i>Send
                                        </button>
                                    </>
                                )   
                            }
                            
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default SupportIndex